import 'bootstrap-sass/assets/javascripts/bootstrap/transition'
import 'bootstrap-sass/assets/javascripts/bootstrap/modal'
// import 'bootstrap-sass/assets/javascripts/bootstrap/collapse'
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown'


import './navigation/navigation'
import hoverDropMenu from './components/header'
// import { BrowserDetect } from './utils/browsers'

import { SearchDropdown } from './navigation/searchDropdown'

// import { Ajax } from '../utils/ajax'
// import { Modals } from '../components/modals'
// import { DataViewport } from '../utils/data-viewport'

$(() => {

  // const browserDetect = window.browserDetect = new BrowserDetect()
  // browserDetect.init()

  hoverDropMenu()

  const searchDropdown = new SearchDropdown()
  searchDropdown.init()


  // const dataViewport = window.dataViewport = new DataViewport()
  // dataViewport.init()

  // const showDropDownCity = new ShowDropDownCity()
  // showDropDownCity.init()

  // const ajax = new Ajax()
  // ajax.init()

  // const modals = window.modals = new Modals()
  // modals.init()
})
